var Action = {
  equal: 0,
  "delete": 1,
  insert: 2,
  none: 3,
  replace: 4
};
export default Action;